export default {
    props: {
        toolbarHome: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'toolbar.home'
        }, 
        toolbarInsert: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'toolbar.insert'
        }, 
        toolbarData: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'toolbar.data'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/KendoSpreadsheet/Toolbar.js